module.exports = __webpack_public_path__ + "img/linux.8d3ecf1a.png";